import type { ReactNode } from 'react';
import { cn } from '@/shared/utils/cn';

type StatusChipProps = {
  // Tailwind background/text/border classes for this status. Each concrete chip
  // supplies its own map so the intentionally-different color schemes stay put.
  toneClass: string;
  label: ReactNode;
  className?: string;
};

// Shared pill markup for the status chips. Renders only the common layout; the
// per-status colors and the translated label are provided by each caller.
export const StatusChip = ({ toneClass, label, className }: StatusChipProps) => (
  <span
    className={cn(
      'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap',
      toneClass,
      className,
    )}
  >
    {label}
  </span>
);
